import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { SectionHeader } from "../../../Common/SharedComponents";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import {
    getChooseAssetsToSellTable,
    getSellableAssets,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { CrystallizationPerContribution } from "../../../Common/SIPP/DrawdownDetails/CrystallizationPerContribution";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { GetRegularCrystallisationAction } from "../../../CancelRegularCrystallisationWizard/Actions/GetRegularCrystallisationAction";
import { RegularDrawdown } from "../../../../../../../Wrap/Models/Domains/Drawdown/RegularDrawdown";
import { StandardRegularDrawdown } from "../../../../../../../Wrap/Models/Domains/Drawdown/StandardRegularDrawdown";
import { CustomerPensionProtectionModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CustomerPensionProtectionModel";
import { EditIncomeDrawdownAction } from "../../../EditIncomeDrawdownWizard/Actions/EditIncomeDrawdownAction";
import { WhatIfAction } from "../../Action/WhatIfAction";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IsRestrictedToPensionContributionWarningText, drawdownDetailsMessage } from "../../../Common/Resource/Contents";
import { SecurityType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    regularDrawdown: RegularDrawdown;
    standardRegularDrawdown: StandardRegularDrawdown;
    CustomerPensionProtectionDetail: CustomerPensionProtectionModel;
    TailoreddrawdownPermittable : boolean;
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            regularDrawdown: null,
            standardRegularDrawdown: null,
            CustomerPensionProtectionDetail: null,
            TailoreddrawdownPermittable: false
        };
    }

    componentDidMount() {
        super.componentDidMount();

        const hierarchyId = getQueryParameters()["hierarchyid"];
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        getSellableAssets(this.props.data.Contribution.Type, hierarchyId, subAccountHierarchyId, (result) => {
            this.setState({ assetsTable: getChooseAssetsToSellTable(this.props.data.Contribution, false, result.assetsToSell) });
        });
        
        this.createAndLoadDrawdownInstruction(this.props.data);
        GetRegularCrystallisationAction.getRegularCrystallisation(hierarchyId, (result) =>
            this.setState({ regularDrawdown: result })
        );

        EditIncomeDrawdownAction.getStandardRegularDrawdown(hierarchyId, (result) =>
            this.setState({ standardRegularDrawdown: result })
        );
        const params = getQueryParameters();
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            0,
            (data: ClientTradableInvestments) => {
                const result = data.CurrentIndividualHoldings.filter(
                    (ele) =>
                        (ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0) &&
                         ele.SecurityType == SecurityType.OffPlatform).every(ele => ele.Permittailoreddrawdown == true);
                this.setState({TailoreddrawdownPermittable : result});
            }) 
    }
    
    private createAndLoadDrawdownInstruction(data: PensionContributionModel) {
        this.setState({ isLoading: true });

        DrawdownCalculationAction.postDrawdown(
            data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                const hierarchyId = getQueryParameters()["hierarchyid"];
                const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
                const type = Number(getQueryParameters()["type"]);
                const batchId = Number(getQueryParameters()["batchid"]);

                WhatIfAction.getInstruction(
                    data?.Contribution?.HierarchyId,
                    hierarchyId,
                    subAccountHierarchyId,
                    data.ClientDetails.ActorId,
                    type,
                    batchId,
                    () => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                    }
                );
            },
            false,
            true,
            true
        );
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (this.state.TailoreddrawdownPermittable == false && this.state.originType == DrawdownType.Regular) {
            return false
        }

        return flag && !isRestrictedProtection;
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getCurProductType(): SubAccountType {
        const clientInfo = ClientAccountStore.getClientAccountInfo();
        const params = getQueryParameters();
        const productType = (clientInfo.SubAccounts || []).find(
            (ele) => ele.HierarchyId == params["subaccounthierarchyid"]
        )?.SubAccountType;
        return productType;
    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        let _data = JSON.parse(JSON.stringify(this.props.data));
        WhatIfAction.saveInstruction(2, _data, this.getCurProductType(), this.props.data.ClientDetails.ActorId, () => {
            this.setState({ isLoading: false });
        });
    };

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        // const isImmediateTaxFreeLumpSum =
        //     data?.SelectedProducts?.find((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType))
        //         ?.PensionType == PensionType.ImmediateTaxFreeLumpSum;
        const isImmediateTaxFreeLumpSum = false;
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.Npr)}
                >
                    <h2>Drawdown details</h2>
                    {this.state.TailoreddrawdownPermittable == false  && data?.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Regular &&(
                    <Alert alertType={AlertType.Error} message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage} />
                )}
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            <PensionProtection
                                {...this.props}
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                process={ProcessType.WhatIf}
                            />
                            <ProtectionInformation
                                {...this.getComponentProps(data, onChange)}
                                process={ProcessType.WhatIf}
                                pensionProtection={data?.Contribution?.PensionProtection}
                            />
                        </>
                    )}
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            {SectionHeader("Drawdown type")}
                            <div className="row">
                                <span className="col-4 h4">{"Drawdown type"}</span>
                                <span className="col-4" data-test="option">
                                    {data?.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Regular &&
                                        "Regular drawdown option"}
                                </span>
                            </div>

                            <NumberTextBoxEditor
                                label="Aunuity purchase age"
                                cssWrapper="control-size-245"
                                // value={this.state.standardRegularDrawdown.Preconditions.AnnuityPurchaseAge}
                                value={75}
                                disabled={false}
                                maxNumberOfDecimalPlaces={{
                                    errorMessage: "only allow Integer",
                                    value: 0,
                                }}
                            ></NumberTextBoxEditor>
                            {
                                <RegularCrystallisation
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.WhatIf}
                                    doCalculation={() => this.doCalculation()}
                                    hierarchyId={data.Contribution.ExistingPensionSubAccountHierarchyId}
                                />
                            }
                            {(data?.Contribution?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.Contribution?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.Contribution?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.Contribution?.PensionProtection) && (
                                    <>
                                        <LTABreakdownDetails
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.WhatIf}
                                            lessThan75={ageLessThan75}
                                            hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                        />
                                    </>
                                )}
                            <TaxFreeLumpSumPayment
                                doCalculation={this.doCalculation}
                                process={ProcessType.WhatIf}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                {...this.getComponentProps(data, onChange)}
                                lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                            />
                            {
                                //PensionType == PensionType.ImmediateTaxFreeLumpSum &&
                                <CrystallizationPerContribution
                                    {...this.getComponentProps(data, onChange)}
                                    modelData={this.props.data?.Contribution}
                                />
                            }
                            {data?.Contribution?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                                <DIAC
                                    {...this.getComponentProps(data, onChange)}
                                    modelData={this.props.data?.Contribution}
                                    existingAccount={false}
                                />
                            )}
                            {showChooseAssetstoSell(
                                data?.Contribution?.DrawdownModel,
                                ChooseAssetsToSellFor.Drawdown
                            ) && (
                                <>
                                    <hr />
                                    <ChooseAssetsToSell
                                        {...this.getComponentProps(data, onChange)}
                                        tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                        assets={this.state.assetsTable}
                                    />
                                    {!data?.Contribution?.DrawdownModel?.IsAcrossAllAssets && (
                                        <ChooseAssetsToSellTable
                                            modelData={data?.Contribution?.DrawdownModel}
                                            data={
                                                data?.Contribution?.DrawdownModel
                                                    ?.PensionCommencementLumpSumAllocations || []
                                            }
                                            reason={ChooseAssetsToSellFor.Drawdown}
                                            tableData={this.state.assetsTable}
                                            onRef={(ref) => this.appendChild(ref)}
                                            onChange={(v) => {
                                                this.onDataChange(
                                                    (changes) =>
                                                        this.onDataChange(onChange, changes, data, "Contribution"),
                                                    { PensionCommencementLumpSumAllocations: v },
                                                    data.Contribution,
                                                    "DrawdownModel"
                                                );
                                            }}
                                            processType={ProcessType.WhatIf}
                                        />
                                    )}
                                </>
                            )}
                            <OAC
                                readonly={true}
                                type={SubAccountType.Npr}
                                onChange={(v) => {}}
                                data={{
                                    OngoingAdviceCharge:
                                        data?.Contribution?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                                }}
                                onRef={(ref) => this.appendChild(ref)}
                            />
                            <ChargesOnIllustration {...this.getProps("Contribution")} />
                        </>
                    )}
                </WizardLinter>
            </PartLoading>
        );
    }
}
